import { _ as _object_spread } from "@swc/helpers/_/_object_spread";
import { Extension } from '@tiptap/core';
import { Plugin, PluginKey } from '@tiptap/pm/state';
import { Slice } from 'prosemirror-model';
import isEmpty from 'lodash/isEmpty';
import { Fragment } from '@tiptap/pm/model';
import { cleanMark as cleanHighlight } from './marks/highlight';
import { cleanMark as cleanTextStyle } from './marks/textStyle';
import { cleanMark as cleanFontFamily } from './marks/fontFamily';
/**
 * Walk all the nodes in the fragment, return new fragment
 */ function filterMarksFromFragment(fragment, editor) {
    const newNodes = [];
    fragment.forEach((node)=>newNodes.push(filterMarksFromNode(node, editor)));
    return Fragment.fromArray(newNodes);
}
function filterMarksFromNode(node, editor) {
    if (node.marks.length > 0) {
        const cleanMarks = node.marks.map((m)=>{
            const attrs = _object_spread({}, cleanHighlight(m), cleanTextStyle(m), cleanFontFamily(m));
            if (!isEmpty(attrs)) {
                return editor.schema.marks[m.type.name].create(attrs);
            }
            return m;
        });
        // mark returns new node with new marks and then copy lets us filter the children
        return node.mark(cleanMarks).copy(filterMarksFromFragment(node.content, editor));
    }
    // No filtering done but we still need new copy so we can process children
    return node.copy(filterMarksFromFragment(node.content, editor));
}
const Paste = Extension.create({
    name: 'da-paste-cleaner',
    addProseMirrorPlugins () {
        return [
            new Plugin({
                key: new PluginKey('da-paste-cleaner'),
                props: {
                    transformPasted: (slice, view)=>{
                        return new Slice(filterMarksFromFragment(slice.content, this.editor), slice.openStart, slice.openEnd);
                    }
                }
            })
        ];
    }
});
export { Paste };

//# sourceMappingURL=paste.js.map